module.exports = __webpack_public_path__ + "static/media/5bcfac07-0808-4d27-bce5-8069c90e9d33_resized.f6830495.jpg";